var map = {
	"./Alle Pramien.jpg": "./src/assets/footer-categories/Alle Pramien.jpg",
	"./Bad & Wellness.jpg": "./src/assets/footer-categories/Bad & Wellness.jpg",
	"./Bestseller.jpg": "./src/assets/footer-categories/Bestseller.jpg",
	"./Bucher & Zeitschriften.jpg": "./src/assets/footer-categories/Bucher & Zeitschriften.jpg",
	"./Gutscheine.jpg": "./src/assets/footer-categories/Gutscheine.jpg",
	"./Haus,  Wohnen & Garten.jpg": "./src/assets/footer-categories/Haus,  Wohnen & Garten.jpg",
	"./Kindertraume & Spiele.jpg": "./src/assets/footer-categories/Kindertraume & Spiele.jpg",
	"./Kochen & Genuss.jpg": "./src/assets/footer-categories/Kochen & Genuss.jpg",
	"./Multimedia & Technik.jpg": "./src/assets/footer-categories/Multimedia & Technik.jpg",
	"./Neue Pramien.jpg": "./src/assets/footer-categories/Neue Pramien.jpg",
	"./Sale.png": "./src/assets/footer-categories/Sale.png",
	"./Sport,  Freizeit & Reisen.jpg": "./src/assets/footer-categories/Sport,  Freizeit & Reisen.jpg"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/footer-categories lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;